import api from '@/api'

export function login (email, password) {
  const data = {
    email,
    password
  }
  return api({
    url: '/login',
    method: 'post',
    data
  })
}

export function logout (token) {
  const data = {
    token
  }
  return api({
    url: '/invalidate',
    method: 'post',
    data
  })
}

export function getUserInfo (token) {
  const data = {
    token
  }
  return api({
    url: '/profile',
    method: 'post',
    data
  })
}

export function resetPassword (data) {
  return api({
    url: '/resetPassword',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/login.js